import { Collapse } from 'antd';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

import { CreateDonationsSchemaType } from '../../schema';
import { highlightedHeaders } from '../DonationsDragger/highlightedHeaders';

const ErrorMessages: FC = () => {
  const { t } = useTranslation('donation.UploadDonationsModal.ErrorMessages');
  const formContext = useFormContext<CreateDonationsSchemaType>();
  const donationsErrorMessages = formContext.formState.errors.donations || [];
  const csvHeaderErrors = formContext.formState.errors.csvHeaders || [];
  const uploadedHeaders = formContext.getValues('csvHeaders') || [];

  return (
    <Collapse className={styles.collapse}>
      {csvHeaderErrors.length && (
        <Collapse.Panel header={t('headers')} key="header">
          <ul className={styles.error}>
            {Object.entries(csvHeaderErrors).map(([key, error]) => {
              if (!error) return null;

              const index = Number(key);

              const message = Array.isArray(error)
                ? error.map((err) => err.message).join(', ')
                : (error as any).message;

              const isExpectedColumn = index < highlightedHeaders.length;

              const actualColumnName =
                uploadedHeaders[index] || `Column ${index + 1}`;

              return (
                <li key={`${message}_${key}`}>
                  {isExpectedColumn
                    ? t('headerMustBe', {
                        index: index + 1,
                        header: highlightedHeaders[index].label,
                      })
                    : t('extraColumn', {
                        columnName: actualColumnName,
                      })}
                </li>
              );
            })}
          </ul>
        </Collapse.Panel>
      )}
      {Array.isArray(donationsErrorMessages) &&
        donationsErrorMessages.map((donationsErrors, i) => {
          if (!donationsErrors) return null;

          return (
            <Collapse.Panel header={`Row #${i + 1}`} key={i}>
              <ul className={styles.error}>
                {Object.values(donationsErrors).map((error, j) => {
                  const message = Array.isArray(error)
                    ? error.map((err) => err.message).join(', ')
                    : (error as any).message;

                  return <li key={`${message}_${j}`}>{message}</li>;
                })}
              </ul>
            </Collapse.Panel>
          );
        })}
    </Collapse>
  );
};

export default ErrorMessages;
